import { UserProfile } from "../../atom/Types";

export const AUTH: string = 'AUTH';
export const SHARETYPE: string = 'SHARETYPE';
export const SHARERENAMEID: string = 'SHARERENAMEID';
export const CONNECTED: string = 'CONNECTED';
export const USERPROFILE: UserProfile = {
    __typename: "",
    id: "",
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    picture: null,
    wishList: []
};
export const ITEMLENGTH: number = 0

export function isAuth(isUserAuthenticated: boolean) {

    return {
        type: AUTH,
        isUserAuthenticated
    };
}
export function ShareType(share: string) {

    return {
        type: SHARETYPE,
        share
    };
}
export function cartLength(len: number) {
    return {
        type: ITEMLENGTH,
        len
    }
}
export function ShareRenameID(id: string) {

    return {
        type: SHARERENAMEID,
        id
    };
}
export function Profile(user: UserProfile) {


    return {
        type: USERPROFILE,
        user
    }
}
export function IsConnected(conn: string) {
    var result = {
        type: CONNECTED,
        connected: {}
    };


    (result.connected as any)[conn] = true;

    return result;
}


interface AuthAction {
    type: string;
    isUserAuthenticated: boolean;
}

interface ShareTypeAction {
    type: string;
    share: string;
}
interface ItemLengthAction {
    type: number
    len: number
}
interface ShareRenameIDAction {
    type: string;
    id: string;
}

interface UserProfileAction {
    type: UserProfile;
    user: object;
}

interface IsConnectedAction {
    type: string;
    connected: {
        [key: string]: boolean;
    };
}

export type QuestionAction = AuthAction | ShareRenameIDAction | ShareTypeAction | UserProfileAction | IsConnectedAction | ItemLengthAction